import { ReportsModule } from "@/modules/reports-objective";
import { Vue, Component } from "vue-property-decorator";
import Grid from "@/components/wijmo-grid/grid/grid.vue";
import { VersionGroupModule } from "@/modules/versiongroup";
import { disabledDueToAccessLevel, getRouteAccessLevel, pureRichText } from "@/util/func";
import { IWorkbookCell } from "wijmo/wijmo.xlsx";
import { fmtMsg } from "commonui";
import { ReportsLocale } from "@/locales/localeid";
import { LevelBinding } from "@/util/constants";
import { AccessLevel } from "@/util/enum";

export interface GridData {
	unit: {
		displayName: string;
		sequence: number;
	};
	component: string;
	levelNumber: string;
	level1: string;
	level2: string;
	level3: string;
	level4: string;
}

export enum UnitDataMapper {
	DisplayNameProp = 1,
	UnitProp = 2
}
@Component({
	components: { Grid }
})
export default class ComponentToObjective extends Vue {
	private levelDataBinding = [LevelBinding.one, LevelBinding.two, LevelBinding.three, LevelBinding.four];
	accessLevel = AccessLevel;

	get isGridLoading() {
		return ReportsModule.componentObjectiveGridLoading;
	}

	getLevelNumber(sequenceArray) {
		return sequenceArray.filter((ele) => !!ele).join(".");
	}

	get currentRouteAccessLevel() {
		return getRouteAccessLevel(this.$route);
	}

	get disabledDueToAccessLevel() {
		return disabledDueToAccessLevel(this.currentRouteAccessLevel);
	}

	gridData() {
		let data: GridData[] = ReportsModule.componentObjectiveReportData.map((currentElement: any) => {
			const currentRow = {
				unit: {
					displayName: this.getUnitData(currentElement.unitId, UnitDataMapper.DisplayNameProp),
					sequence: this.getUnitData(currentElement.unitId, UnitDataMapper.UnitProp)
				},
				component: currentElement.contentName,
				levelNumber: this.getLevelNumber([
					currentElement.level1Sequence,
					currentElement.level2Sequence,
					currentElement.level3Sequence,
					currentElement.level4Sequence
				]),
				level1: currentElement.objectiveLevel1Text,
				level2: currentElement.objectiveLevel2Text,
				level3: currentElement.objectiveLevel3Text,
				level4: currentElement.objectiveLevel4Text
			};
			return currentRow;
		});

		const allLevelNumbers = data.map((d) => d.levelNumber);
		const sortedLevelNumbers = allLevelNumbers.slice().sort(this.customSort);

		data = data.map((d) => {
			return {
				...d,
				levelWeight: sortedLevelNumbers.findIndex((sln) => sln === d.levelNumber)
			};
		});

		return data;
	}

	customSort(a, b) {
		const versionA = a.split(".").map(Number);
		const versionB = b.split(".").map(Number);

		for (let i = 0; i < Math.max(versionA.length, versionB.length); i++) {
			const partA = versionA[i] || 0;
			const partB = versionB[i] || 0;

			if (partA < partB) return -1;
			if (partA > partB) return 1;
		}

		return 0;
	}

	showLevel4Column() {
		return ReportsModule.showLevel4Column;
	}

	getUnitData(unitId: number, ele: UnitDataMapper) {
		const selectedVersionGroup = VersionGroupModule.selectedGsVersion == "-1" ? 1 : 0;
		const res: any = ReportsModule.vcsUnits.filter(
			(unit) => unit.curriculumType === selectedVersionGroup && unitId === unit.id
		);
		if (ele == UnitDataMapper.DisplayNameProp) {
			return res[0].displayName;
		}
		return res[0].unit;
	}

	get exportOptions() {
		return {
			filename: fmtMsg(ReportsLocale.ReportsComponentObjectiveExportedFileName),
			formatCell: (cell: IWorkbookCell, binding: string) => {
				if (cell.value && this.levelDataBinding.includes(binding)) {
					cell.value = pureRichText(cell.value);
				}
			}
		};
	}

	beforeDestroy() {
		ReportsModule.setComponentObjectiveReportData([]);
	}
}
